import React, { memo } from "react";
import { GridBox } from "@pochta/ui";
import { FooterTitle } from "../Footer.styles";
import FooterListFiltered from "./FooterListFiltered";

var FooterList = function FooterList(_ref) {
  var list = _ref.list;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FooterTitle, null, list === null || list === void 0 ? void 0 : list.title), /*#__PURE__*/React.createElement(GridBox, {
    row: true,
    gap: [0, 24]
  }, /*#__PURE__*/React.createElement(FooterListFiltered, {
    list: list === null || list === void 0 ? void 0 : list.items,
    isFirstPart: true
  }), /*#__PURE__*/React.createElement(FooterListFiltered, {
    list: list === null || list === void 0 ? void 0 : list.items
  })));
};

export default /*#__PURE__*/memo(FooterList);